import { action, makeAutoObservable } from "mobx";

export type ToolStatus = {
  done: string;
  working?: string;
  waiting?: string;
  error?: string;
  cancel?: string;
};

export type ToolStatusConfig = Record<string, ToolStatus>;

export class ToolConfigStore {
  toolConfig: ToolStatusConfig = {};

  constructor() {
    makeAutoObservable(this);
  }

  @action setToolConfig(config: ToolStatusConfig) {
    this.toolConfig = config;
  }
}

export const toolConfigStore = new ToolConfigStore();
